// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1IhQM","header":"MergedInvoice_header__2z3oA"};